import React from 'react';
import { motion } from 'framer-motion';
import { Mail, LogIn, Crown, UserCheck, FileText, Trophy } from 'lucide-react';

const steps = [
  { id: 1, name: 'Subscribe', description: 'Choose a plan that fits your needs.', icon: Mail },
  { id: 2, name: 'Receive Emails', description: 'Get weekly updates on opportunities.', icon: LogIn },
  { id: 3, name: 'Access VIP Portal', description: 'Login to explore exclusive content.', icon: Crown },
  { id: 4, name: 'Get Mentorship', description: 'Connect with industry leaders.', icon: UserCheck },
  { id: 5, name: 'Build Your CV', description: 'Enhance your profile with activities.', icon: FileText },
  { id: 6, name: 'Become Top 1%', description: 'Achieve excellence in your field.', icon: Trophy },
];

const HowItWorks = () => {
  return (
    <div className="py-16 bg-rich-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-3xl font-extrabold text-white sm:text-4xl">How It Works</h2>
          <p className="mt-4 text-lg text-medium-gray">
            Your journey to success in 6 simple steps
          </p>
        </div>

        <div className="mt-16">
          <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
            {steps.map((step, index) => (
              <motion.div
                key={step.id}
                className="relative p-6 bg-dark-charcoal border border-white/10 rounded-xl shadow-sm hover:shadow-glow transition-all duration-300"
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: index * 0.1 }}
              >
                <div className="absolute -top-4 left-6 inline-flex items-center justify-center w-8 h-8 text-sm font-bold text-white bg-button-gradient rounded-full shadow-md">
                  {step.id}
                </div>
                <div className="flex flex-col items-center text-center">
                  <div className="flex items-center justify-center w-16 h-16 mb-4 rounded-full bg-vibrant-red/10 text-vibrant-red">
                    <step.icon className="w-8 h-8" />
                  </div>
                  <h3 className="text-xl font-bold text-white">{step.name}</h3>
                  <p className="mt-2 text-medium-gray">{step.description}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HowItWorks;
